import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
} from "@firebase/auth";

const app = initializeApp({
  apiKey: "AIzaSyAntEayU9ztEdhMpH93LhA5AhMZtfHXtO8",
  authDomain: "nap-poet-pin.firebaseapp.com",
  projectId: "nap-poet-pin",
  storageBucket: "nap-poet-pin.appspot.com",
  messagingSenderId: "1041843967378",
  appId: "1:1041843967378:web:a6be177da2c497cf659d4b",
  measurementId: "G-CY7J7J6LMS",
});

export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);

export const createUser = (email: string, password: string) => {
  return createUserWithEmailAndPassword(auth, email, password).then(
    (userCredential) => {
      return sendEmailVerification(userCredential.user);
    }
  );
};

export const signIn = (email: string, password: string) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const signOut = () => {
  return auth.signOut();
};

export const getFileUrl = (path: string) => {
  return getDownloadURL(ref(storage, path));
};

export const sendResetEmail = (email: string) => {
  return sendPasswordResetEmail(auth, email);
};
